import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { IdentityStorage } from 'storage-service-lib';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const identityStorage = inject(IdentityStorage);
  const router = inject(Router);

  const queryParams = new URLSearchParams(route.queryParams);
  const storedNamespace = identityStorage.get()?.namespace;
  const queryNamespace = queryParams.get('namespace');

  // if the query namespace does not match the stored namespace, clear the storage and redirect to signin
  // if no namespace is specified in the query params use stored identity if exists
  const namespaceMatch = !!storedNamespace && (queryNamespace === null || storedNamespace === queryNamespace);
  if (namespaceMatch) {
    return true;
  }

  identityStorage.clear();

  // Bullhorn injects CorporationID into the initial iframe URL.
  const initialParams = new URLSearchParams(window.location.search);
  if (initialParams.has('CorporationID') || route.queryParamMap.has('CorporationID')) {
    return router.parseUrl('/signin?namespace=bullhorn');
  }

  const url = `/signin?${queryParams.toString()}`;
  return router.parseUrl(url);
};
